import BaseController from "confinus_ui/base_controller";
import { showModal } from "lib/overlay/modal";

export default class VoiceOrderOpenerController extends BaseController {
  public static values = {
    modalId: { type: String, default: "" },
  };

  declare private readonly modalIdValue: string;

  public open(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    showModal({ id: this.modalIdValue });
  }
}
